<template>
    <div class="preview-tab-switch" v-if="current3DFile.givenUnitOfLength">
        <div @click="toggleAnalysisTool('Canvas3D')">
            <a
                class="is-size-2 tab-nav-item"
                :class="{ 'is-active': currentAnalysisTool === 'Canvas3D' }"
            >
                <SvgIcon
                    icon="icon--directional_rotate-3-axis"
                    class="is-primary-dark"
                />
            </a>
            <span>{{ $t('checkout.configure.3dRender') }}</span>
        </div>
        <div
            v-if="!current3DFile.repairInfo"
            @click="toggleAnalysisTool('HistogramPictures')"
        >
            <a
                class="is-size-3 tab-nav-item"
                :class="{
                    'is-active': currentAnalysisTool === 'HistogramPictures',
                }"
            >
                <SvgIcon
                    icon="icon--web-application_bar-chart"
                    class="is-primary-dark"
                />
            </a>
            <span>{{ $t('checkout.configure.wallThicknesses') }}</span>
        </div>
        <div
            v-if="current3DFile.repairInfo"
            @click="toggleAnalysisTool('repairAnalysisInfo')"
        >
            <a
                class="is-size-3 tab-nav-item"
                :class="{
                    'is-active': currentAnalysisTool === 'repairAnalysisInfo',
                }"
            >
                <SvgIcon
                    icon="icon--web-application_warning"
                    class="is-primary-dark"
                />
            </a>
            <span>{{ $t('checkout.configure.repairData') }}</span>
        </div>
    </div>
</template>

<script>
import SvgIcon from '../svg/SvgIcon';
import { mapGetters } from 'vuex';
import { eventBus } from '../../events/event-bus';

export default {
    name: 'PreviewTabSwitch',
    components: { SvgIcon },
    data() {
        return {
            currentAnalysisTool: 'Canvas3D',
        };
    },
    computed: {
        ...mapGetters(['current3DFile']),
    },
    methods: {
        toggleAnalysisTool(tool) {
            if (tool !== 'repairAnalysisInfo') {
                this.currentAnalysisTool = tool;
            }
            eventBus.$emit('openAnalysisTool', tool);
        },
    },
};
</script>

<style scoped></style>
